import React, { forwardRef, useMemo } from "react";
import { View, Text, TouchableOpacity, Dimensions } from "react-native";
import BottomSheet, { BottomSheetView } from "@gorhom/bottom-sheet";
import { Ionicons } from "@expo/vector-icons";
import { fontFamily } from "../constants/fonts";
import { colors } from "../constants/theme";

const LocationPermissionBottomSheet = forwardRef(
  ({ message, onOpenSettings }, ref) => {
    const screenHeight = Dimensions.get("window").height;
    const snapPoints = useMemo(
      () => [screenHeight * 0.5, screenHeight * 0.85],
      [screenHeight]
    );

    return (
      <BottomSheet
        ref={ref}
        snapPoints={snapPoints}
        index={-1}
        enablePanDownToClose
        enableOverDrag={false}
        enableDynamicSizing={false}
        detached={true}
        style={{ zIndex: 200, elevation: 200 }}
      >
        <BottomSheetView style={{ flex: 1, paddingHorizontal: 24, paddingBottom: 32 }}>
          {message?.title ? (
            <>
              <View style={{ alignItems: 'center', marginBottom: 24 }}>
                <View style={{ width: 64, height: 64, backgroundColor: colors.disgoBrown, borderRadius: 32, alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                  <Ionicons name="location" size={32} color="white" />
                </View>
                <Text style={{ fontSize: 24, fontFamily: fontFamily.abhayaBold, color: colors.black, textAlign: 'center', marginBottom: 8 }}>
                  {message.title}
                </Text>
                <Text style={{ fontSize: 16, fontFamily: fontFamily.abhaya, color: colors.gray700, textAlign: 'center' }}>
                  {message.message}
                </Text>
              </View>

              <View style={{ marginTop: 16 }}>
                <TouchableOpacity
                  onPress={onOpenSettings}
                  style={{ backgroundColor: colors.disgoBrown, borderRadius: 8, paddingVertical: 16, alignItems: 'center' }}
                >
                  <Text style={{ color: colors.white, fontFamily: fontFamily.abhayaBold, fontSize: 16 }}>
                    Open Settings
                  </Text>
                </TouchableOpacity>
              </View>
            </>
          ) : null}
        </BottomSheetView>
      </BottomSheet>
    );
  }
);

LocationPermissionBottomSheet.displayName = "LocationPermissionBottomSheet";

export default LocationPermissionBottomSheet;
